// extracted by mini-css-extract-plugin
module.exports = {"actorCard":"ActorCard_actorCard__7ZZ1r","actorRole":"ActorCard_actorRole__gZq3J","actorName":"ActorCard_actorName__jteSd","imageWrapper":"ActorCard_imageWrapper__GkGvh"};